export const transformNewProducts = (prod: {value: string}) => ({
  product_category_id: prod.value
})
